import { Box, TextField, Typography } from "@mui/material";

function InputFieldComponent({
  label = "",
  variant = "outlined",
  type = "text",
  required = false,
  value = "",
  multiline = false,
  rows = 1,
  placeholder = "",
  onChangeFn,
}) {
  return (
    <Box>
      <Typography
        sx={{
          mb: 1,
          fontSize: "13px",
          fontWeight: 700,
          letterSpacing: "1px",
          textTransform: "uppercase",
          color: "#e63946",
        }}
      >
        {label}
        {required && (
          <Box
            component="span"
            sx={{
              color: "#ff8c42",
              ml: 0.5,
            }}
          >
            *
          </Box>
        )}
      </Typography>

      <TextField
        type={type}
        fullWidth
        variant={variant}
        required={required}
        value={value}
        multiline={multiline}
        rows={rows}
        placeholder={placeholder}
        onChange={(e) => onChangeFn(e.target.value)}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "20px",
            background: "rgba(15,20,28,0.85)",
            color: "#fff",

            "& fieldset": {
              borderColor: "rgba(230,57,70,0.3)",
            },

            "&:hover fieldset": {
              borderColor: "#e63946",
            },

            "&.Mui-focused fieldset": {
              borderColor: "#e63946",
              borderWidth: "2px",
            },
          },

          "& input": {
            color: "#fff",
          },

          "& textarea": {
            color: "#fff",
          },

          "& input::placeholder": {
            color: "#8e9eaf",
            opacity: 1,
          },

          "& textarea::placeholder": {
            color: "#8e9eaf",
            opacity: 1,
          },
        }}
      />
    </Box>
  );
}

export default InputFieldComponent;